import { useAuth } from "../contexts/AuthContext";

/** true en modo demo o cuando el usuario no puede modificar datos */
export function useReadOnly() {
  const { user } = useAuth();
  return Boolean(user?.solo_lectura);
}
